module.exports = __webpack_public_path__ + "img/logo2.01f322cb.png";